/*eslint no-console: ["error", { allow: ["info", "error"] }] */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { axios } from "~/libs/vp-api-axios";

export const CheerExecutor = {
  methods: {
    cheerFacebook() {
      window.FB.ui({ method: "share", href: this.socialShareUrl },function (response) {
        if (response && !response["error_message"]) {
          this.executeCheer("fb");
        } else {
          console.error("error");
        }
      }.bind(this));
    },
    cheerTwitter() {
      const width = 575;
      const height = 400;
      const left = (screen.width - width) / 2;
      const top = (screen.height - height) / 2;
      const opts = "status=1" + ",width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
      const twitter_window = window.open(this.twitterURL, "twitter_share", opts);
      const timer = setInterval(() =>
      {
        console.info (timer);
        if(twitter_window && twitter_window.closed) {
          this.executeCheer("tw");
          clearInterval(timer);
        }
      },500
      );
    },
    executeCheer(type) {
      let data = {
        shareUrl: this.socialShareUrl,
        articleId: this.articleId,
        message: "",
        fb: 0,
        tw: 0,
      };
      data[type] += 1;
      axios.post(
        "/api/social_api/cheer",data
      ).then((result) => {
        if (result.data.status === 1) {
          this.cheered = true;
          this.cheer_status = "応援中";
          this.cheerCount = result.data.data.count;
          this.cheerUsers.push(result.data.data.cheerInfo[0]);
        }
      }).catch((error)=> {
        console.error(error);
      }).finally(() => {
        this.closeModal();
      });
    }
  }
};
